import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import { APP_PATH, PERMISSION_READ, PERMISSION_CREATE, PERMISSION_UPDATE } from "../Utils/Global";

import PermissionCheck from './Permissions/PermissionCheck';
import RouteCheck from './Permissions/RouteCheck';

import Accueil from './Accueil';
import ActiviteClientList from './Search/ActiviteClientList';
import AlerteList from './Search/AlerteList';
import ClientList from './Search/ClientList';
import ContactList from './Search/ContactList';
import ContratList from './Search/ContratList';
import DonneurOrdreList from './Search/DonneurOrdreList';
import FinanceurList from './Search/FinanceurList';
import LayerPermissionList from './Search/LayerPermissionList';
import ListeDiffusionList from './Search/ListeDiffusionList';
import MotCleList from './Search/MotCleList';
import ObjectifList from './Search/ObjectifList';
import PermissionList from './Search/PermissionList';
import PrestataireList from './Search/PrestataireList';
import ProjetList from './Search/ProjetList';
import ResponsableList from './Search/ResponsableList';
import TarifList from './Search/TarifList';
import ThematiqueList from './Search/ThematiqueList';
import TypeDocumentList from './Search/TypeDocumentList';
import UniteProjetList from './Search/UniteProjetList';
import RequeteList from './Search/RequeteList';
import RequeteDomaineList from './Search/RequeteDomaineList';
import BaliseList from './Search/BaliseList';

import Alerte from './Entity/Alerte';
import Caution from './Entity/Caution';
import Client from './Entity/Client';
import Contact from './Entity/Contact';
import Contrat from './Entity/Contrat';
import DateDeclenchementAlerte from './Entity/DateDeclenchementAlerte';
import Document from './Entity/Document';
import DonneurOrdre from './Entity/DonneurOrdre';
import Echange from './Entity/Echange';
import ElementContrat from './Entity/ElementContrat';
import ElementProjet from './Entity/ElementProjet';
import EtatDesLieux from './Entity/EtatDesLieux';
import Evenement from './Entity/Evenement';
import FacturationEncaissement from './Entity/FacturationEncaissement';
import Financeur from './Entity/Financeur';
import ListeDiffusion from './Entity/ListeDiffusion';
import MotCle from './Entity/MotCle';
import Objectif from './Entity/Objectif';
import Observation from './Entity/Observation';
import Prestataire from './Entity/Prestataire';
import Projet from './Entity/Projet';
import Responsable from './Entity/Responsable';
import Sage from './Entity/Sage';

import Station from './Entity/Station';
import Tarif from './Entity/Tarif';
import Tarification from './Entity/Tarification';
import TaxeFonciere from './Entity/TaxeFonciere';
import Thematique from './Entity/Thematique';
import TypeDocument from './Entity/TypeDocument';
import UniteProjet from './Entity/UniteProjet';

import Valeur from './Entity/Valeur';
import Balise from './Entity/Balise';
import Capteur from './Entity/Capteur';
import CapteurParametre from './Entity/CapteurParametre';
import ContactListExterne from './Search/ContactListExterne';
import ContactsEnvironnement from './Entity/ContactsEnvironnement';
import RequeteDomaineRGPDList from './Search/RequeteDomaineRGPDList';
/**
* Class Navigation
* Navigation component
**/
class Navigation extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props, context) {
    super(props, context);

    const routes = this.getRoutes();
    const menus = this.getMenus();

    this.state = {
      menus: menus,
      routes: routes
    };

    this.setDisplay = this.setDisplay.bind(this);
    this.manageMenus = this.manageMenus.bind(this);
  }

  /**
  * componentWillMount
  * Manage initial menus status
  **/
  componentWillMount() {
    let path = location.pathname;
    let fakeEl = { target: { text: "" } };

    path = path.replace(APP_PATH, "");

    if(path === "/" || path === "") {
      fakeEl.target.text = "Accueil";
    }
    // Administration
    else if(path.startsWith("/administration")) {
      fakeEl.target.text = "Administration test3";
    } else if(path.startsWith("/clients")) {
      fakeEl.target.text = "Clients";
    } else if(path.startsWith("/contacts")) {
      fakeEl.target.text = "Contacts";
    } else if(path.startsWith("/permissions")) {
      fakeEl.target.text = "Permissions";
    // } else if(path.startsWith("/layerpermissions")) {
    //   fakeEl.target.text = "Couches";
    } else if(path.startsWith("/donneurordres")) {
      fakeEl.target.text = "Donneurs d'ordre";
    } else if(path.startsWith("/financeurs")) {
      fakeEl.target.text = "Financeurs";
    } else if(path.startsWith("/listediffusions")) {
      fakeEl.target.text = "Liste de diffusion";
    } else if(path.startsWith("/motcles")) {
      fakeEl.target.text = "Mots-clé";
    }  else if(path.startsWith("/prestataires")) {
      fakeEl.target.text = "Prestataires";
    } else if(path.startsWith("/responsables")) {
      fakeEl.target.text = "Responsables";
    } else if(path.startsWith("/tarifs")) {
      fakeEl.target.text = "Tarifs";
    } else if(path.startsWith("/thematiques")) {
      fakeEl.target.text = "Thématiques";
    } else if(path.startsWith("/typedocuments")) {
      fakeEl.target.text = "Type de document";

  } else if(path.startsWith("/uniteProjets")) {
      fakeEl.target.text = "Unité";
    }
    // Activités client
    else if(path.startsWith("/activitesclient")) {
      fakeEl.target.text = "Activités client";
    }
    // Alertes
    else if(path.startsWith("/alertes")) {
      fakeEl.target.text = "Alertes";
    }
    // Contrats
    else if(path.startsWith("/contrats")) {
      fakeEl.target.text = "Occupations";
    }
    // Objectifs
    else if(path.startsWith("/objectifs")) {
      fakeEl.target.text = "Objectifs";
    }
    // Projets
    else if(path.startsWith("/projets")) {
      fakeEl.target.text = "Projets";
    }
    // Sage
    else if(path.startsWith("/sage")) {
      fakeEl.target.text = "SAGE";
    }
    else if(path.startsWith("/requete")) {
      fakeEl.target.text = "RequeteList";
    }
    else if(path.startsWith("/requeteDomaine")) {
      fakeEl.target.text = "RequeteDomaineList";
    }
    else if(path.startsWith("/requeteDomaineRGPD")) {
      fakeEl.target.text = "RequeteDomaineRGPDList";
    }
    else if(path.startsWith("/balises")) {
      fakeEl.target.text = "BaliseList";
    }
    this.manageMenus(fakeEl);
  }

  /**
  * setDisplay
  * Manage submenu
  **/
  setDisplay(el) {
    const menuEl = el.target.id ? this.refs[el.target.id] : this.refs[el.target.parentElement.id];
    menuEl.hidden = !menuEl.hidden;

    let state = this.state;
    const text = el.target.text;

    for(let i=0; i<state.menus.length; i++) {
      let menu = state.menus[i];

      if(menu.text === text) {
        menu.opened = !menuEl.hidden;
      } else {
        menu.opened = false;

        if(menu.submenu !== undefined) {
          for(let j=0; j<menu.submenu.length; j++) {
            let submenu = menu.submenu[j];

            if(submenu.text === text) {
              submenu.opened = true;
              menu.opened = true;
            } else {
              submenu.opened = false;
            }

            menu.submenu[j] = submenu;
          }
        }
      }

      state.menus[i] = menu;
    }

    this.setState(state);

  }

  /**
  * manageMenus
  * Manage link menu status
  **/
  manageMenus(el, returnState) {
    let state = this.state;
    const text = el.target.text;

    for(let i=0; i<state.menus.length; i++) {
      let menu = state.menus[i];

      if(menu.text === text) {
        menu.opened = true;
      } else {
        menu.opened = false;

        if(menu.submenu !== undefined) {
          for(let j=0; j<menu.submenu.length; j++) {
            let submenu = menu.submenu[j];

            if(submenu.text === text) {
              submenu.opened = true;
              menu.opened = true;
            } else {
              submenu.opened = false;
            }

            menu.submenu[j] = submenu;
          }
        }
      }

      state.menus[i] = menu;
    }

    if(returnState === true) {
      return state;
    }

    this.setState(state);
  }

  /**
  * render
  * Rendering component function : display the navigation
  **/
  render() {
    return (
      <Router>
        <div className="mainView" style={{ display: 'flex' }}>
          <div className="navigationbar">
            <ul style={{ padding: 0 }}>
              { this.getRenderedMenus() }
            </ul>
          </div>
          <div id="view">
            { this.getRenderedRoutes() }
          </div>
        </div>
      </Router>
    );
  }

  getRenderedRoutes() {
    let routes = this.state.routes.map((route, index) => {
      const routeCheckProps = {
        key: index,
        component: route.permissionObject,
        permission: route.permission,
        routeProps: {
          path: APP_PATH + route.path,
          exact: route.exact,
          component: route.main
        }
      };

      return <RouteCheck {...routeCheckProps} />;
    });
    return routes;
  }

  getRenderedMenus() {
    // Rendering the navigation menu
    const menus = this.state.menus.map((menu, index) => {

      // Rendering menu with submenu
      if(menu.submenu !== undefined) {

        const submenus = menu.submenu.map((submenu, index) => (
          <PermissionCheck key={index} component={submenu.permissionObject} permission={PERMISSION_READ}>
            <li onClick={this.manageMenus} className={"navigationbar-entry" + ((submenu.opened) ? " opened" : "")}>
              <Link to={APP_PATH + submenu.path}>{submenu.text}</Link>
            </li>
          </PermissionCheck>
        ));

        return (
          <li key={index} className="navigationbar-entry navigationbar-submenu">
            {/* <Link to={APP_PATH + menu.path} onClick={this.setDisplay} id={"submenu-admin" + index} className={(menu.opened) ? "opened" : ""}>{menu.text}</Link> */}
            <Link to="#" onClick={this.setDisplay} id={"submenu-admin" + index} className={(menu.opened) ? "opened" : ""}>
              {menu.text}<span className="submenu-icon glyphicon glyphicon-align-justify"/>
            </Link>
            <ul ref={"submenu-admin" + index} className={"navigationbar-submenu"} hidden={menu.opened !== true}>
              {submenus}
            </ul>
          </li>
        );

      } else { // Rendering simple menu
        return(
          <PermissionCheck key={index} component={menu.permissionObject} permission={PERMISSION_READ}>
            <li onClick={this.manageMenus} className={"navigationbar-entry" + ((menu.opened) ? " opened" : "")}>
              <Link to={APP_PATH + menu.path}>{menu.text}</Link>
            </li>
          </PermissionCheck>
        );
      }

    });

    return menus;
  }
  /**
  * getRoutes
  * Returns the routes config
  **/
  getRoutes() {
    return [{
      path: '/',
      exact: true,
      main: Accueil,
      permissionObject: "Allow",
      permission: PERMISSION_READ
    },
    // Permissions
    {
      path: '/permissions',
      exact: true,
      main: PermissionList,
      permissionObject: "Permission",
      permission: PERMISSION_READ
    },
    // Permissions sur les couches
    //{
    //  path: '/layerpermissions',
    //  exact: true,
    //  main: LayerPermissionList,
    //  permissionObject: "Permission",
    //  permission: PERMISSION_READ
    //},
    // Donneurs d'ordre
    {
      path: '/donneurordres',
      exact: true,
      main: DonneurOrdreList,
      permissionObject: "DonneurOrdre",
      permission: PERMISSION_READ
    },{
      path: '/donneurordres/add',
      exact: true,
      main: DonneurOrdre,
      permissionObject: "DonneurOrdre",
      permission: PERMISSION_CREATE
    },{
      path: '/donneurordres/:idDonneurOrdre/view',
      exact: true,
      main: DonneurOrdre,
      permissionObject: "DonneurOrdre",
      permission: PERMISSION_READ
    },{
      path: '/donneurordres/:idDonneurOrdre/edit',
      exact: true,
      main: DonneurOrdre,
      permissionObject: "DonneurOrdre",
      permission: PERMISSION_UPDATE
    },
    // Financeurs
    {
      path: '/financeurs',
      exact: true,
      main: FinanceurList,
      permissionObject: "Financeur",
      permission: PERMISSION_READ
    },{
      path: '/financeurs/add',
      exact: true,
      main: Financeur,
      permissionObject: "Financeur",
      permission: PERMISSION_CREATE
    },{
      path: '/financeurs/:idFinanceur/view',
      exact: true,
      main: Financeur,
      permissionObject: "Financeur",
      permission: PERMISSION_READ
    },{
      path: '/financeurs/:idFinanceur/edit',
      exact: true,
      main: Financeur,
      permissionObject: "Financeur",
      permission: PERMISSION_UPDATE
    },
    // Mots-Clé
    {
      path: '/motcles',
      exact: true,
      main: MotCleList,
      permissionObject: "MotCle",
      permission: PERMISSION_READ
    },{
      path: '/motcles/add',
      exact: true,
      main: MotCle,
      permissionObject: "MotCle",
      permission: PERMISSION_CREATE
    },{
      path: '/motcles/:idMotCle/view',
      exact: true,
      main: MotCle,
      permissionObject: "MotCle",
      permission: PERMISSION_READ
    },{
      path: '/motcles/:idMotCle/edit',
      exact: true,
      main: MotCle,
      permissionObject: "MotCle",
      permission: PERMISSION_UPDATE
    },
    // Responsables
    {
      path: '/responsables',
      exact: true,
      main: ResponsableList,
      permissionObject: "Responsable",
      permission: PERMISSION_READ
    },{
      path: '/responsables/add',
      exact: true,
      main: Responsable,
      permissionObject: "Responsable",
      permission: PERMISSION_CREATE
    },{
      path: '/responsables/:idResponsable/view',
      exact: true,
      main: Responsable,
      permissionObject: "Responsable",
      permission: PERMISSION_READ
    },{
      path: '/responsables/:idResponsable/edit',
      exact: true,
      main: Responsable,
      permissionObject: "Responsable",
      permission: PERMISSION_UPDATE
    },
    // Thematiques
    {
      path: '/thematiques',
      exact: true,
      main: ThematiqueList,
      permissionObject: "Thematique",
      permission: PERMISSION_READ
    },{
      path: '/thematiques/add',
      exact: true,
      main: Thematique,
      permissionObject: "Thematique",
      permission: PERMISSION_CREATE
    },{
      path: '/thematiques/:idThematique/view',
      exact: true,
      main: Thematique,
      permissionObject: "Thematique",
      permission: PERMISSION_READ
    },{
      path: '/thematiques/:idThematique/edit',
      exact: true,
      main: Thematique,
      permissionObject: "Thematique",
      permission: PERMISSION_UPDATE
    },
    // Objectifs
    {
      path: '/objectifs',
      exact: true,
      main: ObjectifList,
      permissionObject: "Objectif",
      permission: PERMISSION_READ
    },{
      path: '/objectifs/add',
      exact: true,
      main: Objectif,
      permissionObject: "Objectif",
      permission: PERMISSION_CREATE
    },{
      path: '/objectifs/:idObjectif/view',
      exact: true,
      main: Objectif,
      permissionObject: "Objectif",
      permission: PERMISSION_READ
    },{
      path: '/objectifs/:idObjectif/edit',
      exact: true,
      main: Objectif,
      permissionObject: "Objectif",
      permission: PERMISSION_UPDATE
    },
    // Projets
    {
      path: '/projets',
      exact: true,
      main: ProjetList,
      permissionObject: "Projet",
      permission: PERMISSION_READ
    },{
      path: '/objectifs/:idObjectif/projets/add',
      exact: true,
      main: Projet,
      permissionObject: "Projet",
      permission: PERMISSION_CREATE
    },{
      path: '/projets/:idProjet/view',
      exact: true,
      main: Projet,
      permissionObject: "Projet",
      permission: PERMISSION_READ
    },{
      path: '/projets/:idProjet/edit',
      exact: true,
      main: Projet,
      permissionObject: "Projet",
      permission: PERMISSION_UPDATE
    },
    // Documents < Objectifs
    {
      path: '/:route/:idRoute/documents/add',
      exact: true,
      main: Document,
      permissionObject: "Document",
      permission: PERMISSION_CREATE
    },{
      path: '/documents/:idDocument/view',
      exact: true,
      main: Document,
      permissionObject: "Document",
      permission: PERMISSION_READ
    },{
      path: '/documents/:idDocument/edit',
      exact: true,
      main: Document,
      permissionObject: "Document",
      permission: PERMISSION_UPDATE
    },
    // Contacts
    {
      path: '/contacts',
      exact: true,
      main: ContactList,
      permissionObject: "Contact",
      permission: PERMISSION_READ
    },
    {
      path: '/contacts/add',
      exact: true,
      main: Contact,
      permissionObject: "Contact",
      permission: PERMISSION_CREATE
    },{
      path: '/contacts/:idContact/view',
      exact: true,
      main: Contact,
      permissionObject: "Contact",
      permission: PERMISSION_READ
    },{
      path: '/contacts/:idContact/edit',
      exact: true,
      main: Contact,
      permissionObject: "Contact",
      permission: PERMISSION_UPDATE
    },
    // Contacts
    {
      path: '/contactsEnvironnement',
      exact: true,
      main: ContactListExterne,
      permissionObject: "ContactsEnvironnement",
      permission: PERMISSION_READ
    },
    {
      path: '/contactsEnvironnement/add',
      exact: true,
      main: ContactsEnvironnement,
      permissionObject: "ContactsEnvironnement",
      permission: PERMISSION_CREATE
    },{
      path: '/contactsEnvironnement/:idContact/view',
      exact: true,
      main: ContactsEnvironnement,
      permissionObject: "ContactsEnvironnement",
      permission: PERMISSION_READ
    },{
      path: '/contactsEnvironnement/:idContact/edit',
      exact: true,
      main: ContactsEnvironnement,
      permissionObject: "ContactsEnvironnement",
      permission: PERMISSION_UPDATE
    },
    
    
    // Listes de diffusion
    {
      path: '/listediffusions',
      exact: true,
      main: ListeDiffusionList,
      permissionObject: "ListeDiffusion",
      permission: PERMISSION_READ
    },{
      path: '/listediffusions/add',
      exact: true,
      main: ListeDiffusion,
      permissionObject: "ListeDiffusion",
      permission: PERMISSION_CREATE
    },{
      path: '/listediffusions/:idContact/view',
      exact: true,
      main: ListeDiffusion,
      permissionObject: "ListeDiffusion",
      permission: PERMISSION_READ
    },{
      path: '/listediffusions/:idContact/edit',
      exact: true,
      main: ListeDiffusion,
      permissionObject: "ListeDiffusion",
      permission: PERMISSION_UPDATE
    },
    // Alertes
    {
      path: '/alertes',
      exact: true,
      main: AlerteList,
      permissionObject: "Alerte",
      permission: PERMISSION_READ
    },{
      path: '/:route/:idRoute/alertes/add',
      exact: true,
      main: Alerte,
      permissionObject: "Alerte",
      permission: PERMISSION_CREATE
    },{
      path: '/alertes/add',
      exact: true,
      main: Alerte,
      permissionObject: "Alerte",
      permission: PERMISSION_CREATE
    },{
      path: '/alertes/:idAlerte/view',
      exact: true,
      main: Alerte,
      permissionObject: "Alerte",
      permission: PERMISSION_READ
    },{
      path: '/alertes/:idAlerte/edit',
      exact: true,
      main: Alerte,
      permissionObject: "Alerte",
      permission: PERMISSION_UPDATE
    },
    // DateDeclenchementAlerte < Alerte
    {
      path: '/alertes/:idAlerte/datedeclenchementalertes/add',
      exact: true,
      main: DateDeclenchementAlerte,
      permissionObject: "Alerte",
      permission: PERMISSION_CREATE
    },{
      path: '/datedeclenchementalertes/:idDateDeclenchementAlerte/view',
      exact: true,
      main: DateDeclenchementAlerte,
      permissionObject: "Alerte",
      permission: PERMISSION_READ
    },{
      path: '/datedeclenchementalertes/:idDateDeclenchementAlerte/edit',
      exact: true,
      main: DateDeclenchementAlerte,
      permissionObject: "Alerte",
      permission: PERMISSION_UPDATE
    },
    // ElementProjet
    {
      path: '/projets/:idProjet/elementprojets/add',
      exact: true,
      main: ElementProjet,
      permissionObject: "ElementProjet",
      permission: PERMISSION_CREATE
    },{
      path: '/elementprojets/:idElementProjet/view',
      exact: true,
      main: ElementProjet,
      permissionObject: "ElementProjet",
      permission: PERMISSION_READ
    },{
      path: '/elementprojets/:idElementProjet/edit',
      exact: true,
      main: ElementProjet,
      permissionObject: "ElementProjet",
      permission: PERMISSION_UPDATE
    },
    // Station
    {
      path: '/stations/add',
      exact: true,
      main: Station,
      permissionObject: "Station",
      permission: PERMISSION_CREATE
    },{
      path: '/stations/:idStation/view',
      exact: true,
      main: Station,
      permissionObject: "Station",
      permission: PERMISSION_READ
    },{
      path: '/stations/:idStation/edit',
      exact: true,
      main: Station,
      permissionObject: "Station",
      permission: PERMISSION_UPDATE
    },
    // Observation
    {
      path: '/elementprojets/:idElementProjet/observations/add',
      exact: true,
      main: Observation,
      permissionObject: "Observation",
      permission: PERMISSION_CREATE
    },{
      path: '/observations/:idObservation/view',
      exact: true,
      main: Observation,
      permissionObject: "Observation",
      permission: PERMISSION_READ
    },{
      path: '/observations/:idObservation/edit',
      exact: true,
      main: Observation,
      permissionObject: "Observation",
      permission: PERMISSION_UPDATE
    },
    // Valeur
    {
      path: '/elementprojets/:idElementProjet/valeurs/add',
      exact: true,
      main: Valeur,
      permissionObject: "Valeur",
      permission: PERMISSION_CREATE
    },{
      path: '/valeurs/:idValeur/view',
      exact: true,
      main: Valeur,
      permissionObject: "Valeur",
      permission: PERMISSION_READ
    },{
      path: '/valeurs/:idValeur/edit',
      exact: true,
      main: Valeur,
      permissionObject: "Valeur",
      permission: PERMISSION_UPDATE
    },
    // Contrats
    {
      path: '/contrats',
      exact: true,
      main: ContratList,
      permissionObject: "Contrat",
      permission: PERMISSION_READ
    },{
      path: '/objectifs/:idObjectif/contrats/add',
      exact: true,
      main: Contrat,
      permissionObject: "Contrat",
      permission: PERMISSION_CREATE
    },{
      path: '/contrats/:idContrat/view',
      exact: true,
      main: Contrat,
      permissionObject: "Contrat",
      permission: PERMISSION_READ
    },{
      path: '/contrats/:idContrat/edit',
      exact: true,
      main: Contrat,
      permissionObject: "Contrat",
      permission: PERMISSION_UPDATE
    },
    // EtatDesLieux
    {
      path: '/contrats/:idContrat/etatdeslieux/add',
      exact: true,
      main: EtatDesLieux,
      permissionObject: "EtatDesLieux",
      permission: PERMISSION_CREATE
    },{
      path: '/etatdeslieux/:idEtatDesLieux/view',
      exact: true,
      main: EtatDesLieux,
      permissionObject: "EtatDesLieux",
      permission: PERMISSION_READ
    },{
      path: '/etatdeslieux/:idEtatDesLieux/edit',
      exact: true,
      main: EtatDesLieux,
      permissionObject: "EtatDesLieux",
      permission: PERMISSION_UPDATE
    },
    // TaxeFonciere
    {
      path: '/contrats/:idContrat/taxefoncieres/add',
      exact: true,
      main: TaxeFonciere,
      permissionObject: "TaxeFonciere",
      permission: PERMISSION_CREATE
    },{
      path: '/taxefoncieres/:idTaxeFonciere/view',
      exact: true,
      main: TaxeFonciere,
      permissionObject: "TaxeFonciere",
      permission: PERMISSION_READ
    },{
      path: '/taxefoncieres/:idTaxeFonciere/edit',
      exact: true,
      main: TaxeFonciere,
      permissionObject: "TaxeFonciere",
      permission: PERMISSION_UPDATE
    },
    // Evenement
    {
      path: '/contrats/:idContrat/evenements/add',
      exact: true,
      main: Evenement,
      permissionObject: "Evenement",
      permission: PERMISSION_CREATE
    },{
      path: '/tarifications/:idTarification/evenements/add',
      exact: true,
      main: Evenement,
      permissionObject: "Evenement",
      permission: PERMISSION_CREATE
    },{
      path: '/evenements/:idEvenement/view',
      exact: true,
      main: Evenement,
      permissionObject: "Evenement",
      permission: PERMISSION_READ
    },{
      path: '/evenements/:idEvenement/edit',
      exact: true,
      main: Evenement,
      permissionObject: "Evenement",
      permission: PERMISSION_UPDATE
    },
    // Echange
    {
      path: '/contrats/:idContrat/echanges/add',
      exact: true,
      main: Echange,
      permissionObject: "Echange",
      permission: PERMISSION_CREATE
    },{
      path: '/echanges/:idEchange/view',
      exact: true,
      main: Echange,
      permissionObject: "Echange",
      permission: PERMISSION_READ
    },{
      path: '/echanges/:idEchange/edit',
      exact: true,
      main: Echange,
      permissionObject: "Echange",
      permission: PERMISSION_UPDATE
    },
    // ElementContrat
    {
      path: '/contrats/:idContrat/elementcontrats/add',
      exact: true,
      main: ElementContrat,
      permissionObject: "ElementContrat",
      permission: PERMISSION_CREATE
    },{
      path: '/elementcontrats/:idElementContrat/view',
      exact: true,
      main: ElementContrat,
      permissionObject: "ElementContrat",
      permission: PERMISSION_READ
    },{
      path: '/elementcontrats/:idElementContrat/edit',
      exact: true,
      main: ElementContrat,
      permissionObject: "ElementContrat",
      permission: PERMISSION_UPDATE
    },
    // Tarification
    {
      path: '/tarifications/:idTarification/view',
      exact: true,
      main: Tarification,
      permissionObject: "Tarification",
      permission: PERMISSION_READ
    },{
      path: '/tarifications/:idTarification/edit',
      exact: true,
      main: Tarification,
      permissionObject: "Tarification",
      permission: PERMISSION_UPDATE
    },
    // Tarif
    {
      path: '/tarifs',
      exact: true,
      main: TarifList,
      permissionObject: "Tarif",
      permission: PERMISSION_READ
    },{
      path: '/tarifs/add',
      exact: true,
      main: Tarif,
      permissionObject: "Tarif",
      permission: PERMISSION_CREATE
    },{
      path: '/tarifs/:idTarif/view',
      exact: true,
      main: Tarif,
      permissionObject: "Tarif",
      permission: PERMISSION_READ
    },{
      path: '/tarifs/:idTarif/edit',
      exact: true,
      main: Tarif,
      permissionObject: "Tarif",
      permission: PERMISSION_UPDATE
    },
    // Caution
    {
      path: '/contrats/:idContrat/cautions/add',
      exact: true,
      main: Caution,
      permissionObject: "Caution",
      permission: PERMISSION_CREATE
    },{
      path: '/cautions/:idCaution/view',
      exact: true,
      main: Caution,
      permissionObject: "Caution",
      permission: PERMISSION_READ
    },{
      path: '/cautions/:idCaution/edit',
      exact: true,
      main: Caution,
      permissionObject: "Caution",
      permission: PERMISSION_UPDATE
    },
    // FacturationEncaissement
    {
      path: '/contrats/:idContrat/facturationencaissements/add',
      exact: true,
      main: FacturationEncaissement,
      permissionObject: "FacturationEncaissement",
      permission: PERMISSION_CREATE
    },
    {
      path: '/sage',
      exact: true,
      main: Sage,
      permissionObject: "FacturationEncaissement",
      permission: PERMISSION_CREATE
    },
    {
      path: '/requete',
      exact: true,
      main: RequeteList,
      permissionObject: "Requete",
      permission: PERMISSION_CREATE
    },{
      path: '/requeteDomaine',
      exact: true,
      main: RequeteDomaineList,
      permissionObject: "RequeteDomaine",
      permission: PERMISSION_CREATE
    },{
      path: '/requeteDomaineRGPD',
      exact: true,
      main: RequeteDomaineRGPDList,
      permissionObject: "RequeteDomaineRGPD",
      permission: PERMISSION_CREATE
    },{
      path: '/facturationencaissements/:idFacturationEncaissement/view',
      exact: true,
      main: FacturationEncaissement,
      permissionObject: "FacturationEncaissement",
      permission: PERMISSION_READ
    },{
      path: '/facturationencaissements/:idFacturationEncaissement/edit',
      exact: true,
      main: FacturationEncaissement,
      permissionObject: "FacturationEncaissement",
      permission: PERMISSION_UPDATE
    },
    // TypeDocument
    {
      path: '/typedocuments',
      exact: true,
      main: TypeDocumentList,
      permissionObject: "TypeDocument",
      permission: PERMISSION_READ
    },{
      path: '/typedocuments/add',
      exact: true,
      main: TypeDocument,
      permissionObject: "TypeDocument",
      permission: PERMISSION_CREATE
    },{
      path: '/typedocuments/:idTypeDocument/view',
      exact: true,
      main: TypeDocument,
      permissionObject: "TypeDocument",
      permission: PERMISSION_READ
    },{
      path: '/typedocuments/:idTypeDocument/edit',
      exact: true,
      main: TypeDocument,
      permissionObject: "TypeDocument",
      permission: PERMISSION_UPDATE
    },

    // UniteProjet
    {
      path: '/uniteprojets',
      exact: true,
      main: UniteProjetList,
      permissionObject: "UniteProjet",
      permission: PERMISSION_READ
    },{
      path: '/uniteprojets/add',
      exact: true,
      main: UniteProjet,
      permissionObject: "UniteProjet",
      permission: PERMISSION_CREATE
    },{
      path: '/uniteprojets/:idUniteProjet/view',
      exact: true,
      main: UniteProjet,
      permissionObject: "UniteProjet",
      permission: PERMISSION_READ
    },{
      path: '/uniteprojets/:idUniteProjet/edit',
      exact: true,
      main: UniteProjet,
      permissionObject: "UniteProjet",
      permission: PERMISSION_UPDATE
    },
    // Client
    {
      path: '/clients',
      exact: true,
      main: ClientList,
      permissionObject: "Client",
      permission: PERMISSION_READ
    },{
      path: '/clients/add',
      exact: true,
      main: Client,
      permissionObject: "Client",
      permission: PERMISSION_CREATE
    },{
      path: '/clients/:idClient/view',
      exact: true,
      main: Client,
      permissionObject: "Client",
      permission: PERMISSION_READ
    },{
      path: '/clients/:idClient/edit',
      exact: true,
      main: Client,
      permissionObject: "Client",
      permission: PERMISSION_UPDATE
    },
    // Prestataire
    {
      path: '/prestataires',
      exact: true,
      main: PrestataireList,
      permissionObject: "Prestataire",
      permission: PERMISSION_READ
    },{
      path: '/prestataires/add',
      exact: true,
      main: Prestataire,
      permissionObject: "Prestataire",
      permission: PERMISSION_CREATE
    },{
      path: '/prestataires/:idPrestataire/view',
      exact: true,
      main: Prestataire,
      permissionObject: "Prestataire",
      permission: PERMISSION_READ
    },{
      path: '/prestataires/:idPrestataire/edit',
      exact: true,
      main: Prestataire,
      permissionObject: "Prestataire",
      permission: PERMISSION_UPDATE
    },
    // Activités Client
    // {
    //   path: '/activitesclient',
    //   exact: true,
    //   main: ActiviteClientList,
    //   permissionObject: "Client",
    //   permission: PERMISSION_READ
    // },
    // Balise
    // 
    // 
  ];
  }

  /**
  * getMenus
  * Returns the menus config
  **/
  getMenus() {
    return [{
      text: "Accueil",
      permissionObject: "Allow",
      path: "/"
    }, {
      text: "Administration",
      path: "/administration",
      submenu: [
      // {
      //   text: "Alertes",
      //   permissionObject: "Alerte",
      //   path: "/alertes"
      // }, 
      {
        text: "Clients",
        permissionObject: "Client",
        path: "/clients"
      },{
        text: "Contacts interne",
        permissionObject: "Contact",
        path: "/contacts"
      },{
        text: "Contacts domaine",
        permissionObject: "ContactsEnvironnement",
        path: "/contactsEnvironnement"
      }
      // ,
      // {
      //   text: "Couches",
      //   permissionObject: "Permission",
      //   path: "/layerpermissions"
      // }
      ,{
        text: "Donneurs d'ordre",
        permissionObject: "DonneurOrdre",
        path: "/donneurordres"
      },{
        text: "Financeurs",
        permissionObject: "Financeur",
        path: "/financeurs"
      },{
        text: "Listes de diffusion",
        permissionObject: "ListeDiffusion",
        path: "/listediffusions"
      },{
        text: "Mots-clé",
        permissionObject: "MotCle",
        path: "/motcles"
      },{
        text: "Permissions",
        permissionObject: "Permission",
        path: "/permissions"
      },{
        text: "Prestataires",
        permissionObject: "Prestataire",
        path: "/prestataires"
      },{
        text: "Responsables",
        permissionObject: "Responsable",
        path: "/responsables"
      },{
        text: "Tarifs",
        permissionObject: "Tarif",
        path: "/tarifs"
      },{
        text: "Thématiques",
        permissionObject: "Thematique",
        path: "/thematiques"
      },{
        text: "Type de document",
        permissionObject: "TypeDocument",
        path: "/typedocuments"
      }]
    }, //{
    //   text: "Activités client",
    //   permissionObject: "Client",
    //   path: "/activitesclient"
    // }, 
    {
      text: "Occupations",
      permissionObject: "Contrat",
      path: "/contrats"
    }, {
      text: "Objectifs",
      permissionObject: "Objectif",
      path: "/objectifs"
    }, {
      text: "Projets",
      permissionObject: "Projet",
      path: "/projets"
    }, //{
    //   text: "Systèmes de mesure",
    //   permissionObject: "Balise",
    //   path: "/balises"
    // },
    {
      text: "SAGE",
      permissionObject: "FacturationEncaissement",
      path: "/sage"
    },{
      text: "Requêtes 'Environnement'",
      permissionObject: "Requete",
      path: "/requete"
    },{
      text: "Requêtes 'Domaine'",
      permissionObject: "RequeteDomaine",
      path: "/requeteDomaine"
    },{
      text: "Requêtes Domaine Spécifiques",
      permissionObject: "RequeteDomaineRGPD",
      path: "/requeteDomaineRGPD"
    }];
  }

}

export default Navigation;



// WEBPACK FOOTER //
// ./src/views/Navigation.js